import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TitleService {
    private title: string = "";
    public onTitleChange: Subject<string>;

    public constructor() {
        this.onTitleChange = new Subject<string>();
    }

    public getTitle(): string {
        return this.title;
    }

    public setTitle(title: string): void {
        this.title = title;
        this.onTitleChange.next(title);
    }
}